/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql, useLazyQuery } from '@apollo/client';

export const useGetDisplayIndicativePriceRange = () => {

    const GET_DISPLAY_INDICATIVE_PRICE_RANGE = gql`
    query RangePrice($request: IndicativePriceInRangeInput!) {
    getDisplayIndicativePriceInRange(request: $request) {
    EntitledPrice {
      RangePrice {
        currency
        maximumQuantity {
          uom
          value
        }
        minimumQuantity {
          uom
          value
        }
        priceInRange {
          currency
          value
        }
      }
      UnitPrice {
        price {
          currency
          value
        }
        quantity {
          uom
          value
        }
      }
      contractId
      partNumber
      productId
    }
    resourceId
    resourceName
  }
}
    `;

    const [RangePriceCall, RangePriceDetails]= useLazyQuery(GET_DISPLAY_INDICATIVE_PRICE_RANGE,{
      fetchPolicy:"network-only",
       context:{
        clientName:"/product/price"
      }
    });
      return {RangePriceCall, RangePriceDetails };
}